var _path, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTagIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0275 3.28651C12.8211 3.07901 12.5396 2.96313 12.2472 2.96313H6.72872C6.43624 2.96313 6.1548 3.07901 5.94841 3.28651L2.63735 6.59757C2.42985 6.80396 2.31396 7.0843 2.31396 7.37788V12.8963C2.31396 13.1899 2.42985 13.4702 2.63735 13.6766L13.6742 24.7135C13.8894 24.9287 14.172 25.0369 14.4545 25.0369C14.7371 25.0369 15.0196 24.9287 15.2348 24.7135L24.0643 15.884C24.4959 15.4525 24.4959 14.7549 24.0643 14.3234L13.0275 3.28651ZM14.4545 22.3726L4.52134 12.4394V7.83481L7.18564 5.1705H11.7902L21.7234 15.1037L14.4545 22.3726Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.32559,
    cy: 9.97485,
    rx: 1.81777,
    ry: 1.81777,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcon);
export default __webpack_public_path__ + "static/media/tag-icon.6314d02462c6256d13bceb4652763dbd.svg";
export { ForwardRef as ReactComponent };